/**
 * @file: 商品tpl申明
 * @author: xiaolong.huang@dmall.com
 */

/**
 * 已测试覆盖 √
 * 测试用例: test/tpl/index.ts
 */
let tpl: string = `
    <div class="shelvesbuild-e-g-default" data-stagecore>
        <!-- 流动线 -->
        <span class="flow-border-left"><i></i></span>
        <span class="flow-border-right"><i></i></span>
        <span class="flow-border-top"><i></i></span>
        <span class="flow-border-bottom"><i></i></span>

        <div class="default-nail-box"></div>
        <div class="goods sub">
            <div class="g-sub">
                <!-- 字码 -->
                <div class="goods-table J_Sub"></div>
            </div>
        </div>
        <div class="goods main-goods">
            <div class=" g-left">
                <!-- 左侧叠放 -->
                <div class="goods-table J_Left"></div>
            </div>
            <div class="g-box">
                <div class="g-top">
                    <!-- 上侧叠放 -->
                    <div class="goods-table J_Top"></div>
                </div>

                <div class="g-center">
                    <!-- 主商品 -->
                    <div class="goods-table J_Center"></div>
                </div>

                <div class="g-bottom ">
                    <!-- 下侧叠放 -->
                    <div class="goods-table J_Bottom"></div>
                </div>
            </div>
            <div class="g-right">
                <!-- 右侧叠放 -->
                <div class="goods-table J_Right"></div>
            </div>

            <!-- 挂钉 -->
            <div class="default-attr-box">
                <div class="dish hide"></div>
            </div>

            <!-- 用于图块模式展示文案 -->
            <div class="default-tags hide"></div>

            <!-- 卧柜商品吸附提示线 -->
            <div class="close-line-tips"></div>

            <!-- 卧柜自动布局列纵向插入位置辅助线 -->
            <div class="insert-line-col"></div>
        </div>
        <div class="auto-flag"></div>
        <div class="align-line-tips"></div>

        <!-- 商品标签 -->
        <div class="shelvesbuild-e-g-default__tag-list">
            <i class="hasSubList"></i>
            <i class="ware-tag"></i>
            <i class="not-display"></i>
        </div>

        <!-- 上层板标识 -->
        <i class="shelvesbuild-e-g-default__in-layer"></i>

        <span class="selected-mask"></span>
    </div>`;

export default tpl;
